// LiveStreamGift.js
import { connect } from 'react-redux';
import Gift from '../component/Gift.jsx';
import notifySendGift from '../action/notifySendGift.js';
import sendLiveStreamGift from '../action/sendLiveStreamGift.js';
import pushToastr from '../action/pushToastr.js';
import toggleModal from '../action/toggleModal.js';
import openQuickpayModal from '../action/openQuickpayModal.js';
import addvalue from '../action/addvalue.js';
import login from '../action/login.js';
import getGiftData from '../selector/getGiftData.js';
import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getHasEnoughBalanceForGift from '../selector/getHasEnoughBalanceForGift.js';
import getMeData from '../selector/getMeData.js';
import {
  LIVESTREAM_ANIMATION_GIFTS,
  LIVESTREAM_ANIMATION_PAG_GIFTS,
} from '../RemoteConfigKeys.js';

const getGiftI18nKey = id => `giftname_${id.replace(/-/g, '_')}`;

/**
 * mapStateToProps
 * @param {Object} state - the root state from redux store
 * @param {string} { id } - gift id
 * @return {Object} the object will be the props in the connected component
 */
function mapStateToProps(state, { id, isActive }) {
  const animationGiftList = getRemoteConfigData(
    state,
    LIVESTREAM_ANIMATION_GIFTS
  );
  const pagGiftList = getRemoteConfigData(
    state,
    LIVESTREAM_ANIMATION_PAG_GIFTS
  );

  const isAnimationGift = !!animationGiftList.includes(id);
  const isPagGift = !!pagGiftList.includes(id);
  const pagImage = isPagGift ? getGiftData(state, id, 'pagImage') : '';

  return {
    i18nKey: getGiftI18nKey(id),
    image: getGiftData(state, id, 'image'),
    pagImage,
    price: getGiftData(state, id, 'price'),
    isSwiping: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isGiftPanelSwiping'
    ),
    isAnimationGift,
    isPagGift,
    isActive,
    isSendingGift:
      'sending' ===
      getOperationData(state, ['liveStream', 'gift'], 'giftSendingStatus'),
    isNeedSendGiftConfirm: getOperationData(
      state,
      ['liveStream'],
      'isNeedSendGiftConfirm'
    ),
    hasEnoughBalance: getHasEnoughBalanceForGift(state, id),
    hasPurchased: getMeData(state, 'hasPurchased'),
    isLoggedIn: !!getMeData(state, 'token'),
  };
}

function mapDispatchToProps(dispatch, { streamId }) {
  return {
    sendGift: ({ giftId }) =>
      dispatch(sendLiveStreamGift({ giftId, streamId })),
    notifySendGift: ({ giftId }) =>
      dispatch(notifySendGift({ streamId, giftId })),
    pushToastr: data => dispatch(pushToastr(data)),
    addvalue: () => dispatch(addvalue({ via: 'gift' })),
    login: () => dispatch(login({ shouldChooseEntryOption: false })),
    openAnimationFailedModal: ({ giftId, isAnimationGift, isPagGift }) =>
      dispatch(
        toggleModal({
          modalId: 'GiftAnimationFailedConfirmModal',
          payload: {
            animationFailedGiftId: giftId,
            isAnimationGift,
            isPagGift,
            streamId,
          },
          isOpen: true,
        })
      ),
    openGiftSendConfirmModal: ({ giftId }) =>
      dispatch(
        toggleModal({
          modalId: 'LivestreamGiftSendConfirmModal',
          payload: {
            giftId,
            streamId,
          },
          isOpen: true,
        })
      ),
    openQuickpayModal: data => dispatch(openQuickpayModal(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Gift);
